export enum DeletePopupType {
  Delete = 'Delete',
  DeleteForce = 'DeleteForce',
}